export default {
  title: 'Welcome',
  subtitle: 'Sign in to manage your account and orders',
  benefits: {
    earn_points: {
      title: 'Earn points with every order',
      description: 'Collect points and unlock exclusive rewards',
    },
    get_deals: {
      title: 'Receive exclusive discounts',
      description: 'Use your points to get free items',
    },
    redeem_points: {
      title: 'Redeem points for free food',
      description: 'Get access to member-only promotions',
    },
  },
};
